import { getAuth } from '@firebase/auth';
import { doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { UserType } from '../firestoreSchema'

export async function listenToCurrentUserData(callback: any) {
  getAuth().onAuthStateChanged((user) => {
    if (user && user.uid) {
      getUserPublic(user.uid).then(callback);
    } else {
      callback(undefined);
    }
  });
}

export async function getUserPublic(uid: string) {
  try {
    let document = await getDoc(doc(getFirestore(), 'users', uid));
    let data = document.data();
    if(data) { data.uid = uid };
    return data as UserType;
  } catch {
    return undefined;
  }
}


export async function updateCurrentUser(updates: any) {
  const currUser = getAuth().currentUser;
  if(currUser) {
    await setDoc(
        doc(getFirestore(), 'users', currUser.uid),
          updates,
          { merge: true }
    );
  }
}

